// "use strict";

import HeadControls from "./HeadControls";

//GLOBALs DECLARATION :
//images and their position
const CIRCLE_RAD = 20;
const MARGIN = 3;
var videoWidth, videoHeight;
var DATA = [];
var clickable_rectangles = [];
var MARGIN_X = 0,
  MARGIN_Y = 0,
  SCALE = 1;

var position_nos = [];
//variable to check whether window is open or not
var ISWINOPEN = false;
var JQCURS,
  JQCLICKABLES = [],
  POINTERPOSITION = [0, 0];
var count = 0;
var balls_no = 3;
var vueCtx;

var STABI = {
  //stabilizer
  sensibility: 0.01, //0.003
  am: 0.8, //0.9,
  pow: 1.8,
  t: Date.now(),
  speed: [0, 0],
  speedAm: [0, 0],
  rxy: [0, 0],
  xy: [window.innerWidth / 2, window.innerHeight / 2],
  mouseClickEnabled: true
};

var live = {
  drawPicture(spec) {
    // draws tranlucent green circle
    setTimeout(function() {
      var cv = document.getElementById("images");
      var ctx = cv.getContext("2d");
      //ctx.fillStyle = "#00A308"; // plain green
      ctx.fillStyle = "rgba(255, 255, 0, .7)"; //translucent green
      ctx.beginPath();
      var center_x = spec.center_x;
      var center_y = spec.center_y;
      var arc_length = spec.rad_length;
      ctx.arc(center_x, center_y, arc_length, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
    }, 500);
  },
  removePicture() {
    // clear the entire canvas
    setTimeout(function() {
      var cv = document.getElementById("images");
      var ctx = cv.getContext("2d");
      ctx.clearRect(0, 0, videoWidth, videoHeight);
    }, 500);
  },
  drawBrightPicure(spec) {
    var cv = document.getElementById("images");
    var ctx = cv.getContext("2d");
    ctx.fillStyle = "#00A308"; // plain green
    ctx.beginPath();
    var center_x = spec.center_x;
    var center_y = spec.center_y;
    var arc_length = spec.rad_length;
    ctx.arc(center_x, center_y, arc_length, 0, Math.PI * 2, true);
    ctx.closePath();
    ctx.fill();
  }, //end if spec.url
  updatePointerPosition(x, y) {
    POINTERPOSITION[0] = x;
    POINTERPOSITION[1] = y;
    JQCURS.css("left", Math.round(POINTERPOSITION[0]).toString() + "px");
    JQCURS.css("top", Math.round(POINTERPOSITION[1]).toString() + "px");
  },
  callbackHeadMove(mv) {
    /*if (mv.dZ!==0) { //move head forward/backward
        }*/
    var x = window.innerWidth / 2,
      y = window.innerHeight / 2;
    var am = STABI.am;

    var t = Date.now();
    var dt = Math.min(t - STABI.t, 50);
    STABI.t = t;

    if (Math.abs(mv.dRx) > 200 || Math.abs(mv.dRy) > 200) {
      console.log("Invalid value");
      return;
    }

    //compute speed :
    //STABI.speed[0]+=(mv.dRx-STABI.rxy[0])/dt,
    //STABI.speed[1]+=(mv.dRy-STABI.rxy[1])/dt;

    (STABI.speed[0] =
      -Math.pow(Math.abs(mv.dRx), STABI.pow) * Math.sign(mv.dRx)),
      (STABI.speed[1] =
        -Math.pow(Math.abs(mv.dRy), STABI.pow) * Math.sign(mv.dRy));

    //STABI.speed[0]+=(mv.dRx-STABI.rxy[0])/dt,
    //STABI.speed[1]+=(mv.dRy-STABI.rxy[1])/dt;

    //amortize speed :
    (STABI.speedAm[0] = STABI.speedAm[0] * am + (1 - am) * STABI.speed[0]),
      (STABI.speedAm[1] = STABI.speedAm[1] * am + (1 - am) * STABI.speed[1]);

    //save position :
    (STABI.rxy[0] = mv.dRx), (STABI.rxy[1] = mv.dRy);

    //apply amortized speed :
    STABI.xy[0] +=
      STABI.sensibility *
      dt *
      Math.pow(STABI.speedAm[1], 2) *
      Math.sign(STABI.speedAm[1]);
    STABI.xy[1] -=
      STABI.sensibility *
      (window.innerWidth / window.innerHeight) *
      dt *
      Math.pow(STABI.speedAm[0], 2) *
      Math.sign(STABI.speedAm[0]);

    STABI.xy[0] = Math.max(0, STABI.xy[0]);
    STABI.xy[0] = Math.min(STABI.xy[0], window.innerWidth - 30);

    STABI.xy[1] = Math.max(0, STABI.xy[1]);
    STABI.xy[1] = Math.min(STABI.xy[1], window.innerHeight - 30);

    live.updatePointerPosition(STABI.xy[0], STABI.xy[1]);

    if (mv.expressions[0] > 0.5 && STABI.mouseClickEnabled) {
      //mouth open
      //emulateMouseClick(STABI.xy[0],STABI.xy[1]);
      STABI.mouseClickEnabled = false;
      setTimeout(function() {
        STABI.mouseClickEnabled = true;
      }, 500);
    }
    live.emulateMouseMove(STABI.xy[0], STABI.xy[1]);
  }, //end callbackMove()
  getPickableAtPosition(x, y) {
    // gets position of mouse. If outside imited range, moves it inside. If is over the rectangle that contains
    //the circle, then highlights the circle and clear the canvas, and then draws the next picture.

    if (x > videoWidth) {
      live.updatePointerPosition(videoWidth, y);
      x = videoWidth;
    }
    if (y > videoHeight) {
      live.updatePointerPosition(x, videoHeight);
      y = videoHeight;
    }
    if (count < balls_no) {
      var rect = clickable_rectangles[position_nos[count] - 1];
      if (x < rect.left || x > rect.right) {
        return false;
      }
      if (y < rect.top || y > rect.bottom) {
        return false;
      }
      var selected_position = DATA[position_nos[count] - 1];
      live.drawBrightPicure(selected_position);
      live.removePicture();

      count = count + 1;
      if (count < balls_no) {
        var selected_position = DATA[position_nos[count] - 1];
        live.drawPicture(selected_position);
      }
    }
    if (count === balls_no) {
      // once finished, take 'screenshot' of the video and detect the face.
      count = count + 1;
      console.log("LIVENESS DETECTION COMPLETED");
      // NECESARIO PARA LA DETECCIÓN DE LA CARA
      // var videoCanvas = document.getElementById('myvideo');
      // var dataURL = videoCanvas.toDataURL();
      // var element = angular.element(document.getElementById('canvasPyCapture'));
      // var scope = element.scope();
      // scope.$root.$broadcast('testLive', { finish: true });
      vueCtx.$emit("testLive", { finish: true });
      //var imageToTrack = live.convertDataURIToBinary(dataURL); // convert from base64 to binary so that we can use tracking
      //trackFace(dataURL);
      // var rect = tracking2();
      // var rect = trackingFace(document.getElementById('img'));
      // faceTrack2();
      // live.positionLoop();
    }
    //faceTrack(dataURL);
  },
  emulateMouseMove(x, y) {
    if (ISWINOPEN) return;
    var jqUnderCursor = live.getPickableAtPosition(x, y);
    JQCLICKABLES.forEach(jq => {
      if (jq === jqUnderCursor) {
        jq.addClass("vignetteMouseOver");
      } else {
        jq.removeClass("vignetteMouseOver");
      }
    });
  },
  convertDataURIToBinary(dataURI) {
    var BASE64_MARKER = ";base64,";
    var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    var base64 = dataURI.substring(base64Index);
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));
    var i;
    for (i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  },
  // trackingFace(image){
  //     var tracker = new tracking.ObjectTracker(['face']);
  //     tracker.setStepSize(1.7);
  //     tracking.track('#img', tracker);
  //     tracker.on('track', function(event) {
  //     event.data.forEach(function(rect) {
  //         print(rect.x, rect.y, rect.width, rect.height);
  //     });
  //     return {x: rect.x, y: rect.y, width: rect.width, height:rect.height}
  //     });
  // },
  // trackFace(base64){
  //     var c = document.getElementById("screenshot");
  //     var ctx = c.getContext('2d');
  //     var image = document.getElementById('faces2');
  //     image.src = base64;
  //     var tracker = new tracking.ObjectTracker(['face']);
  //     image.onload  = function () {
  //         ctx.drawImage(image, 0, 0);
  //         tracker.setStepSize(1.7);
  //         tracking.track('#screenshot', tracker);

  //     }
  //     tracker.on('track', function(event) {
  //         if (event.data.length === 0) {
  //             // No colors were detected in this frame.
  //         } else {
  //             event.data.forEach(function(rect) {
  //                 //window.plot(rect.x, rect.y, rect.width, rect.height);
  //                 // console.log(rect.x)
  //                 // console.log('hola')
  //             });
  //         }
  //     });
  // },
  // faceTrack(base64){
  //     var c = document.getElementById("myvideo");
  //     var cc= document.getElementById('screenshot');
  //     var ctxs = cc.getContext('2d');
  //     var ctx = c.getContext('2d');
  //     var image = document.getElementById('faces2');
  //     image.src = base64;
  //     var ctracker = new clm.tracker({stopOnConvergence : true});
  //     ctracker.init();
  //     image.onload = function(){
  //         ctxs.drawImage(image, 0, 0);
  //         var position= false
  //         var n = ctracker.start(c);
  //         // console.log(n);
  //         while (position == false){
  //             var news = ctracker.getCurrentPosition();
  //             var hey = ctracker.getConvergence();
  //             // console.log(hey)
  //             // console.log(news)
  //         }
  //         // console.log('GOOD')
  //     }
  // },
  // faceTrack2() {
  //     var c = document.getElementById("myvideo");
  //     var ctx = c.getContext('2d');
  //     var ctracker = new clm.tracker({stopOnConvergence : true});
  //     ctracker.init();
  //     var position= false
  //     var n = ctracker.start(c);
  //     // console.log(n);
  //     while (position == false){
  //         var news = ctracker.getCurrentPosition();
  //         var hey = ctracker.getConvergence();
  //         // console.log(hey)
  //         // console.log(news)
  //     }
  //     // console.log('GOOD')
  // },
  positionLoop(ctracker) {
    requestAnimationFrame(live.positionLoop);
    var positions = ctracker.getCurrentPosition();
    // positions = [[x_0, y_0], [x_1,y_1], ... ]
    console.log(positions[0]);
  },
  mainLifeTest(width, height, vueContext) {
    vueCtx = vueContext;
    videoWidth = width;
    videoHeight = height;

    DATA.push({
      center_x: CIRCLE_RAD + MARGIN * 2,
      center_y: CIRCLE_RAD + MARGIN * 2,
      rad_length: CIRCLE_RAD
    }); // TOP LEFT
    DATA.push({
      center_x: videoWidth - CIRCLE_RAD - MARGIN,
      center_y: CIRCLE_RAD + MARGIN * 2,
      rad_length: CIRCLE_RAD
    }); // TOP RIGHT
    DATA.push({
      center_x: CIRCLE_RAD + MARGIN * 2,
      center_y: videoHeight - CIRCLE_RAD - MARGIN,
      rad_length: CIRCLE_RAD
    }); // BOTTOM LEFT
    DATA.push({
      center_x: videoWidth - CIRCLE_RAD - MARGIN,
      center_y: videoHeight - CIRCLE_RAD - MARGIN,
      rad_length: CIRCLE_RAD
    }); // BOTTOM RIGHT

    clickable_rectangles.push({
      top: 0,
      left: 0,
      bottom: 2 * CIRCLE_RAD,
      right: 2 * CIRCLE_RAD
    });
    clickable_rectangles.push({
      top: 0,
      left: videoWidth - 2 * CIRCLE_RAD,
      bottom: 2 * CIRCLE_RAD,
      right: videoWidth
    });
    clickable_rectangles.push({
      top: videoHeight - 2 * CIRCLE_RAD,
      left: 0,
      bottom: videoHeight,
      right: 2 * CIRCLE_RAD
    });
    clickable_rectangles.push({
      top: videoHeight - 2 * CIRCLE_RAD,
      left: videoWidth - 2 * CIRCLE_RAD,
      bottom: videoHeight,
      right: videoWidth
    });

    JQCURS = window.$("#cursor");

    window.$(document).mousemove(function(event) {
      live.updatePointerPosition(event.pageX, event.pageY);
    });
    var i = 0;
    while (i < balls_no) {
      // here a randomly ordered list is generated with the positions (from the 4 corners) in which the pictures will be drawn.
      var position_no = Math.floor(Math.random() * 4) + 1;
      while (position_nos.includes(position_no)) {
        position_no = Math.floor(Math.random() * 4) + 1;
      }
      position_nos.push(position_no);
      i = i + 1;
    }
    var selected_position = DATA[position_nos[0] - 1];
    //selected_position.forEach(addPicture);
    live.drawPicture(selected_position);

    window
      .$(document)
      .click(function(event) {
        if (!ISWINOPEN) return;
        //    closeContent();
        event.stopPropagation();
        return false;
      })
      .on("selectstart", event => {
        event.preventdefault();
        return false;
      });

    // var NNCPath = './'
    // alert(process.env.NODE_ENV)
    // if (process.env.NODE_ENV === 'development') {
    //     NNCPath = '/static/'
    // }
    HeadControls.init({
      canvasId: "canvasVideo",
      callbackMove: live.callbackHeadMove,
      callbackReady: function(err) {
        if (err) {
          console.log(
            "ERROR in index.html : HEAD CONTROLS NOT READY. err =",
            err
          );
        } else {
          console.log("INFO in index.html : HEAD CONTROLS ARE READY :)");
        }
        HeadControls.toggle(true);
      },
      NNCpath: "/static/", // where to find NNC.json from this path
      animateDelay: 2, // avoid DOM lags
      disableRestPosition: true
    }); //end HeadControls.init params
  } //end main()
};

export default live;
